import React, { useEffect, useState } from 'react';
import { Link, Navigate, Outlet } from 'react-router-dom';
import { Container, Row, Col, Button, Nav, Image } from 'react-bootstrap';
import Swal from 'sweetalert2';
import logo from '../assests/Site-icon.jpg';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function AdminDashboard() {
    const [isAdmin, setIsAdmin] = useState(localStorage.getItem('isAdmin') === 'true');

    useEffect(() => {
        if (localStorage.getItem('isAdmin') !== 'true') {
            setIsAdmin(false);
        }
    }, []);

    if (!isAdmin) {
        return <Navigate to="/admin-login" />;
    }

    const handleLogout = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "You will be logged out!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, logout!",
        }).then((result) => {
            if (result.isConfirmed) {
                localStorage.removeItem('isAdmin');
                window.location.href = "/";
            }
        });
    };

    return (
        <Container fluid>
            <Row className="vh-1 ">
                {/* Sidebar */}
                <Col md={1} style={{ backgroundColor: '#F5A119' , width:'20vh' }} className=" text-white p-1 d-flex flex-column ">
                    <div className="text-center mb-4">
                        <Image src={logo} 
                        style={{
                            width:'6vw'
                        }}
                        alt="logo" className="img-fluid" rounded />
                    </div>
                    <Nav className="flex-column">
                        <Nav.Link as={Link} to="/admin-dashboard" className="text-white">
                            <i className="bi bi-house-fill me-1"></i>Dashboard
                        </Nav.Link>
                        <Nav.Link as={Link} to="/admin-dashboard/users" className="text-white">
                            <i className="bi bi-people-fill me-2"></i>Users
                        </Nav.Link>
                        <Nav.Link as={Link} to="/admin-dashboard/AdminPriceList" className="text-white">
                            <i className="bi bi-people-fill me-2"></i>Price List
                        </Nav.Link>
                    </Nav>
                    <div style={{
                        marginTop:'50vh'
                    }}>
                        <Button variant="danger" className="w-100" onClick={handleLogout}>
                            <i className="bi bi-box-arrow-right me-2"></i> Logout
                        </Button>
                    </div>
                </Col>

                {/* Main Content */}
                <Col md={10} className="p-4 bg-light">
                    <Outlet />
                </Col>
            </Row>
        </Container>
    );
}

export default AdminDashboard;
